<template>
  <div>
    <AppHeader />
    <Suspense>
      <RouterView />
    </Suspense>
    <!-- tableOfContents 頁面不顯示 footer -->
    <AppFooter v-if="shouldShowFooter" />
  </div>
</template>

<script>
import AppHeader from "@/layout/AppHeader.vue";
import AppFooter from "@/layout/AppFooter.vue";
import { RouterView } from "vue-router";

export default {
  components: {
    AppHeader,
    AppFooter,
  },
  computed: {
    shouldShowFooter() {
      return this.$route.name !== "tableOfContents";
    },
  },
};
</script>
